module.exports = __webpack_public_path__ + "static/media/Privacy.e7b5ffba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/Privacy.svg
// module id = 1137
// module chunks = 0